import { render } from "./SeatColumn.vue?vue&type=template&id=35d70a1b"
import script from "./SeatColumn.vue?vue&type=script&lang=js"
export * from "./SeatColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__